import React from "react";
import { NavLink } from "react-router-dom";
import { WidgetProps } from "../widgets";

type MembershipWidgetProps = {} & WidgetProps;

export const MembershipWidget: React.FC<MembershipWidgetProps> = (props: MembershipWidgetProps) => {
	return (
		<div className="container">
			<section>
				<h1 className="text-center">
					<div>Not yet a member?</div>
					<div>
						{/*<NavLink to="/join">Join</NavLink> */}
						Join your B&W community today.
					</div>
				</h1>
				<p className="py-4">
					All permanent employees of the Los Angeles County Fire Department are eligible for membership. The
					operating costs of the association are supported by a voluntary monthly payroll deduction from the
					active membership. The cost is $20 per month and is tax deductible. For enrollment assistance,
					contact your Battalion Director.
				</p>
			</section>
			<section className="section-padding">
				<h1 className="text-center">How to Join</h1>
				<div className="d-flex flex-column flex-md-row streams-card-container align-items-stretch justify-content-center">
					<div className="card bg-light flex-grow-991">
						<div className="card-body d-flex flex-column align-items-center">
							<h3 className="d-flex flex-row align-items-center">
								<span className="step">1</span> Enrollment
							</h3>
							<p className="my-3">Download the Enrollment Form and return to LACFBW.</p>
							<NavLink to="/registration-form">
								<button className="btn btn-info">Download Form</button>
							</NavLink>
						</div>
					</div>
					<div className="card bg-light">
						<div className="card-body d-flex flex-column align-items-center">
							<h3 className="d-flex flex-row align-items-center">
								<span className="step">2</span> Get Firewire App
							</h3>
							<p className="my-3">
								Join the community by{" "}
								<a href="https://firewireapp.com/" target="_blank">
									downloading Firewire app
								</a>{" "}
								and get instant access to our classifieds, personalized message board and upcoming event
								details.
								{/*Download Firewire App and verify employment.*/}
							</p>
							<a href="https://firewireapp.com/" target="_blank">
								<button className="btn btn-primary">Firewire App</button>
							</a>
						</div>
					</div>
				</div>
			</section>
		</div>
	);
};
